var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDoubleLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8169 3.51637C15.061 3.76045 15.061 4.15618 14.8169 4.40025L9.21722 9.99998L14.8169 15.5997C15.061 15.8438 15.061 16.2395 14.8169 16.4836C14.5729 16.7277 14.1771 16.7277 13.9331 16.4836L7.89139 10.4419C7.64731 10.1978 7.64731 9.80211 7.89139 9.55804L13.9331 3.51637C14.1771 3.27229 14.5729 3.27229 14.8169 3.51637Z",
    fill: "#222729"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0249 3.51637C10.269 3.76045 10.269 4.15618 10.0249 4.40025L4.42522 9.99998L10.0249 15.5997C10.269 15.8438 10.269 16.2395 10.0249 16.4836C9.78087 16.7277 9.38514 16.7277 9.14107 16.4836L3.0994 10.4419C2.85532 10.1978 2.85532 9.80211 3.0994 9.55804L9.14107 3.51637C9.38514 3.27229 9.78087 3.27229 10.0249 3.51637Z",
    fill: "#222729"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoubleLeft);
export default __webpack_public_path__ + "static/media/icon-double-left.61e5bb0cd293dfc5014d4ac0a8e08c76.svg";
export { ForwardRef as ReactComponent };